import React from "react";
import { siteConfigurations } from "../shared/sites/sites";
import { getLocalizedPath } from "../shared/formatURL";
import Link from "next/link";

export default function ImageComponent({
  action,
  reviewStatus,
  translations,
  type,
}: {
  action: any;
  reviewStatus: string;
  translations: any;
  type: string;
}) {
  // const customPrompts = action.post.customPrompt
  //   .split(",")
  //   .map((item: string) => item.trim())
  //   .filter((item: string) => item !== "");
  const customPrompts =
    action.post?.customPrompt !== undefined
      ? action.post.customPrompt
          .split(",")
          .map((item: string) => item.trim())
          .filter((item: string) => item !== "")
      : [];

  const localizedPostPath = getLocalizedPath("post");

  // console.log(customPrompts);

  function manipulateString(input: string): string {
    let str = input;
    str = str
      .replace(/[\[\]\(\):.\d{}<>]/g, "")
      .replace(/\s+/g, " ")
      .replace(/,([^ ])/g, ", $1");
    if (str.endsWith(",")) {
      str = str.slice(0, -1);
    }
    if (str.endsWith(", ")) {
      str = str.slice(0, -2);
    }
    return str;
  }

  const shouldShowPost = (status: string) => status === "none" || status === "approved";

  return (
    <>
      <div className="mb-auto w-auto border-b-[0.5px] border-l-[0.5px] border-r-[0.5px] border-[#3C3C3C] bg-[#2B2D31] shadow-md sm:rounded-bl-md sm:rounded-br-md">
        {!shouldShowPost(reviewStatus) ? (
          <></>
        ) : type === "image" ? (
          // POST
          <div className="flex flex-wrap px-4 pb-2 text-sm text-white md:px-4">
            {action.tagStringArray?.map((tag: any, index: any) => (
              <Link
                prefetch={false}
                href={`${localizedPostPath}/search?search=${encodeURIComponent(tag.tagName)}`} //href={`${getLocalizedPath("tags")}/${tag.id}`}
                key={index}
                className={`mb-2 mr-2 rounded-full border-[0.5px] border-[#3C3C3C] px-5 py-[4.5px] text-sm font-medium text-white ${
                  tag.ugc && "border border-ugc-tags"
                }`}
              >
                {tag.tagName}
              </Link>
            ))}
          </div>
        ) : (
          // GIF
          <div className="flex flex-wrap px-4 pb-2 text-sm text-white md:px-4">
            {action.tagStringArray?.map((tag: any, index: any) => (
              <Link
                prefetch={false}
                href={`${localizedPostPath}/search?search=${encodeURIComponent(tag)}`} //href={`${getLocalizedPath("tags")}/${tag.id}`}
                key={index}
                className="mb-2 mr-2 rounded-full border-[0.5px] border-[#3C3C3C] px-5 py-[4.5px] text-sm font-medium text-white"
              >
                {tag}
              </Link>
            ))}
          </div>
        )}
      </div>
      {action.post?.customPrompt !== undefined &&
        action.post?.customPrompt !== "" &&
        action.post?.customPrompt !== "," &&
        (process.env.NEXT_PUBLIC_BASE_URL === "http://localhost:3000" ||
        process.env.NEXT_PUBLIC_BASE_URL === "https://www.8porn.ai"
          ? true
          : siteConfigurations[action.post?.origin]?.siteUrl ===
            process.env.NEXT_PUBLIC_BASE_URL) && (
          <div className="mt-[16px] mt-[20px] w-auto border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] shadow-md sm:rounded-md">
            <div className="px-5 pt-4 text-sm font-medium text-white">
              {translations.useOfCustomPrompt}
            </div>
            <div className="px-5 py-4 text-sm font-medium text-white">
              {/* {`${action.post.customPrompt}`.replace(/,([^,]*)$/, "$1")} */}
              <div>
                {!shouldShowPost(reviewStatus) ? (
                  <></>
                ) : (
                  <>
                    {customPrompts.map((prompt: string, index: number) => (
                      <Link
                        prefetch={false}
                        key={index}
                        href={`/post/search?search=${encodeURIComponent(manipulateString(prompt))}`}
                        // className="inline-block"
                      >
                        {index === customPrompts.length - 1
                          ? prompt.replace(/,([^,]*)$/, "$1")
                          : prompt.replace(/,([^,]*)$/, "$1") + ", "}
                      </Link>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      <div className="mt-[20px] w-auto border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] shadow-md sm:rounded-md">
        <div className="px-5 pt-4 text-sm font-medium text-white">
          ⚠ {translations.AIPornDisclaimer}
        </div>
        <div className="px-5 py-4 text-sm font-medium text-white">
          {translations.AIPornDisclaimerText1}{" "}
          <a
            href={`${process.env.NEXT_PUBLIC_BASE_URL}${translations.path}create`}
            className="underline"
          >
            {translations.AIPornDisclaimerText2}
          </a>
        </div>
      </div>
    </>
  );
}
